import { render, staticRenderFns } from "./ListCategories.vue?vue&type=template&id=57d4e9b2&scoped=true&"
import script from "./ListCategories.vue?vue&type=script&lang=js&"
export * from "./ListCategories.vue?vue&type=script&lang=js&"
import style0 from "./ListCategories.vue?vue&type=style&index=0&id=57d4e9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d4e9b2",
  null
  
)

export default component.exports